import { render, staticRenderFns } from "./WorkEditorDialog.vue?vue&type=template&id=f44b946e&scoped=true&lang=pug&"
import script from "./WorkEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkEditorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WorkEditorDialog.vue?vue&type=style&index=0&id=f44b946e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44b946e",
  null
  
)

export default component.exports